import React from 'react';
import { Loader, Flex } from '@grubhubprod/gh-cookbook-react/dist';
import { useCorporateFieldsContext } from 'src/components/enterprise/features/Corporate/components/CorporateFieldsData/hooks/useCorporateFieldsContext';
import { DinerNotificationPreferences } from 'src/components/enterprise/features/Corporate/components/Form/DinerNotificationPreferences/DinerNotificationPreferences';

export function DinerNotificationPreferencesWrapper(): JSX.Element {
  const { corpFieldsData, loading } = useCorporateFieldsContext();
  const dinerNotificationPreferences =
    corpFieldsData?.dinerNotificationPreferences || [];

  if (loading) {
    return (
      <Flex alignItems="center" justifyContent="center">
        <Loader size="md" />
      </Flex>
    );
  }

  return (
    <DinerNotificationPreferences
      dinerNotificationPreferences={dinerNotificationPreferences}
    />
  );
}
